import React from 'react'
import { Header } from '../components/comman/Header'
import { MainComponent } from '../components/LandingPage/MainComponent'
import Footer from '../components/comman/Footer'

export const HomePage = () => {
  return (
    <div>
    <Header/>
    <MainComponent/>
    <Footer/>
    </div>
  )
}
